import axios, { createServerApi } from "@/api/lib";

const http = axios;

import {
  PARK_DETAIL,
  SEND_CODE,
  UPLOAD_FILE,
  VALIDATE_CODE,
  ADD_PARK,
  UPDATE_PARK,
  UNDO_PARK,
  FIND_BY_PHONE,
  GET_YQZY_LIST,
  GET_YQDT_LIST,
  GET_YQZC_LIST,
  GET_YQHD_LIST,
  GET_PARK_LIST,
  GET_DIMENSION_LIST,
  GET_DISTRICT_LIST,
  GET_CODE_LIST,
  GET_PARK_INDUSTRY_LIST,
  GET_PARK_CAPITAL_LIST,
  GET_PARK_COM_LIST,
  GET_YQDT_DETAIL,
  GET_YQZC_DETAIL,
  GET_YQHD_DETAIL,
  GET_INDUSTRY_TYPE,
  GET_USER_BACK,
  GET_ENTERPRISE,
  GET_CODE_ID,
  CHECK_IS_MANAGER,
  GET_CURRENT_USER_NAME,
} from "@/api/constants/url";

const serverName = "/jpaas-jmap-web-server";
const qfptName = "/qfpt-api";

const api = createServerApi(serverName);
const qfptApi = createServerApi(qfptName);

const parkAPI = {
  getEnterprise (params) {
    return http({
      url: qfptApi(GET_ENTERPRISE, true),
      method: "get",
      headers: {
        "Portal-Authorization": params.Token,
      },
    });
  },
  getUserInfo (params) {
    return http({
      url: `/yybApi${GET_CURRENT_USER_NAME}`,
      method: "get",
      // params: params,
      isEncode: true,
      headers: {
        "Portal-Authorization": params.Token,
        token: params.Token,
      },
    });
  },
  parkDetail (params) {
    return http({
      url: api(PARK_DETAIL),
      method: "get",
      params: params,
    });
  },
  getCodeId (params) {
    return http({
      url: api(GET_CODE_ID),
      method: "get",
      params: params,
    });
  },
  sendCode (data) {
    return http({
      url: api(SEND_CODE),
      method: "post",
      data: data,
    });
  },
  uploadFile (formData) {
    return http({
      headers: {
        "Content-Type": "multipart/form-data",
      },
      url: api(UPLOAD_FILE),
      method: "post",
      data: formData,
    });
  },
  validateCode (data) {
    return http({
      url: api(VALIDATE_CODE),
      method: "post",
      data: data,
    });
  },
  addPark (data, token) {
    return http({
      url: api(ADD_PARK),
      method: "post",
      data: data,
      headers: {
        "access-token": token,
      },
    });
  },
  updatePark (data) {
    return http({
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
        "Content-Type": "multipart/form-data",
      },
      url: api(UPDATE_PARK),
      method: "post",
      data: data,
    });
  },
  undoPark (data) {
    return http({
      url: api(UNDO_PARK),
      method: "post",
      data: data,
    });
  },
  findByPhone (params, token) {
    return http({
      url: api(FIND_BY_PHONE),
      method: "get",
      params: params,
      headers: {
        "access-token": token,
      },
    });
  },
  getYqzyList (params) {
    return http({
      url: api(GET_YQZY_LIST),
      method: "get",
      params: params,
    });
  },
  getYqdtList (params) {
    return http({
      url: api(GET_YQDT_LIST),
      method: "get",
      params: params,
    });
  },
  getYqzcList (params) {
    return http({
      url: api(GET_YQZC_LIST),
      method: "get",
      params: params,
    });
  },
  getYqhdList (params) {
    return http({
      url: api(GET_YQHD_LIST),
      method: "get",
      params: params,
    });
  },
  getParkList (params) {
    return http({
      url: api(GET_PARK_LIST),
      method: "get",
      params: params,
    });
  },
  getDimensionList (params) {
    return http({
      url: api(GET_DIMENSION_LIST),
      method: "get",
      params: params,
    });
  },
  getDistrictList (params) {
    return http({
      url: api(GET_DISTRICT_LIST),
      method: "get",
      params: params,
    });
  },
  getCodeList (params) {
    return http({
      url: api(GET_CODE_LIST),
      method: "get",
      params: params,
    });
  },
  getParkIndustryList (params) {
    return http({
      url: api(GET_PARK_INDUSTRY_LIST),
      method: "get",
      params: params,
    });
  },
  getParkCapitalList (params) {
    return http({
      url: api(GET_PARK_CAPITAL_LIST),
      method: "get",
      params: params,
    });
  },
  getParkComList (params) {
    return http({
      url: api(GET_PARK_COM_LIST),
      method: "get",
      params: params,
    });
  },
  getYqdtDetail (params) {
    return http({
      url: api(GET_YQDT_DETAIL),
      method: "get",
      params: params,
    });
  },
  getUserBack (params) {
    return http({
      url: api(GET_USER_BACK),
      method: "post",
      data: params,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  getYqzcDetail (params) {
    return http({
      url: api(GET_YQZC_DETAIL),
      method: "get",
      params: params,
    });
  },
  getYqhdDetail (params) {
    return http({
      url: api(GET_YQHD_DETAIL),
      method: "get",
      params: params,
    });
  },
  getIndustryType (params) {
    return http({
      url: api(GET_INDUSTRY_TYPE),
      method: "get",
      params: params,
    });
  },
  checkIsManager (params) {
    return http({
      url: api(CHECK_IS_MANAGER),
      method: "get",
      params: params,
    });
  },
};

export default parkAPI;
